/** Inclusive lower bound for 4xx client error responses. */
export const HTTP_CLIENT_ERROR_MIN = 400;

/** Inclusive lower bound for 5xx server error responses; exclusive upper bound for 4xx. */
export const HTTP_SERVER_ERROR_MIN = 500;
